/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Pricing_Eur_PriceInputs */

const en_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const de_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const fr_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const es_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const it_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const nl_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const pl_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const fi_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const da_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

const sv_pricing_eur_price = /** @type {(inputs: Pricing_Eur_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`EUR ${i?.price}`)
};

/**
* | output |
* | --- |
* | "EUR {price}" |
*
* @param {Pricing_Eur_PriceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_eur_price = /** @type {((inputs: Pricing_Eur_PriceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Eur_PriceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_eur_price(inputs)
	if (locale === "fr") return fr_pricing_eur_price(inputs)
	if (locale === "es") return es_pricing_eur_price(inputs)
	if (locale === "it") return it_pricing_eur_price(inputs)
	if (locale === "nl") return nl_pricing_eur_price(inputs)
	if (locale === "pl") return pl_pricing_eur_price(inputs)
	if (locale === "fi") return fi_pricing_eur_price(inputs)
	if (locale === "da") return da_pricing_eur_price(inputs)
	if (locale === "sv") return sv_pricing_eur_price(inputs)
	return en_pricing_eur_price(inputs)
});